module.exports = __webpack_public_path__ + "static/media/canvaswelcomepage.ab5ccb6a.png";